import { atom } from "recoil";

export type ExceedType = {
  isOpen: boolean;
  orderId: string;
  index: number;
  hotel_name: string;
  ordered_at: string;
  delivery_expected_at: string | null;
};

export const exceedState = atom<ExceedType>({
  key: "exceedState",
  default: {
    isOpen: false,
    orderId: "",
    index: 0,
    hotel_name: "",
    ordered_at: "",
    delivery_expected_at: null,
  },
});
